<template>
  <div class="flex flex-col items-center">
    <b-headline type="h2" typography="h2" :responsive="false" class="mb-12 text-center m:px-0">
      {{ $t("features.growthStats.growthHeadline") }}
      <b-tooltip class="inline-block align-text-top" :content="$t('userReviews.tooltip')" />
    </b-headline>

    <div class="grid gap-x-8 gap-y-8 m:gap-y-2 grid-cols-1 m:grid-cols-3">
      <growth-card v-bind="$props">
        <template v-slot:icon>
          <crown-icon class="w-12 text-blue" />
        </template>
        <template v-slot:title>
          {{ $t("features.growthStats.totalDownloads", { totalUsers: totalUsers }) }}
        </template>
        <template v-slot:details>
          {{ $t("features.growthStats.downloads") }}
        </template>
      </growth-card>
      <growth-card v-bind="$props">
        <template v-slot:icon>
          <div class="flex w-full justify-center items-center pt-4">
            <star-rating :value="1" class="w-6 h-6 mr-1 inline-flex" v-for="n in starRatingWhole" :key="n" />
            <star-rating v-if="showFractionalStar" :value="starRatingFraction" class="w-6 h-6 mr-0 inline-flex" />
          </div>
        </template>
        <template v-slot:title>
          {{ $t("features.growthStats.starRating", { rating: $n(averageRating) }) }}
        </template>
        <template v-slot:details>
          {{ $t("features.growthStats.ratings") }}
        </template>
      </growth-card>
      <growth-card v-bind="$props">
        <template v-slot:icon>
          <plant-icon class="w-12 text-blue" />
        </template>
        <template v-slot:title> 91% </template>
        <template v-slot:details>
          {{ $t("features.growthStats.habit") }}
        </template>
      </growth-card>
      <div class="text-mid-grey m:col-start-3 px-0 m:px-8 text-sm text-center -mt-4 m:mt-0">
        {{ $t("features.growthStats.habitInfo") }}
      </div>
    </div>
  </div>
</template>

<script>
import globals from "@/utils/globals"
import BHeadline from "@/component-library/b-headline"
import i18n from "@/modules/i18n"
import growthCard from "@/component-library/growth-card"
import crownIcon from "@/component-library/icons/crown-icon"
import plantIcon from "@/component-library/icons/plant-icon"
import starRating from "@/component-library/star-rating"

const LAST_KNOWN_AGGREGATED_RATING = 4.6

export default {
  name: "GrowthStats",
  components: {
    BHeadline,
    growthCard,
    crownIcon,
    plantIcon,
    starRating
  },
  props: {
    signupRoute: {
      type: String,
      required: false,
      default: ""
    },
    showTrialEndDate: {
      type: Boolean,
      default: false
    },
    hideCta: {
      type: Boolean,
      default: false
    },
    ctaCopy: {
      type: String,
      required: false,
      default: null
    },
    modifiers: {
      type: Array,
      default: () => {}
    }
  },
  computed: {
    averageRating() {
      const { stars: iosRating } = globals.smartbanner.rating.ios
      const { stars: androidRating } = globals.smartbanner.rating.android

      if (iosRating && androidRating) {
        return Math.round(((iosRating + androidRating) / 2) * 10) / 10
      }

      if (iosRating) {
        return iosRating
      }

      if (androidRating) {
        return androidRating
      }

      return LAST_KNOWN_AGGREGATED_RATING
    },
    starRatingWhole() {
      return Math.floor(this.averageRating)
    },
    starRatingFraction() {
      return this.averageRating - this.starRatingWhole
    },
    showFractionalStar() {
      return this.starRatingFraction > 0
    },
    totalUsers() {
      return globals.totalUsers
    }
  },
  i18n: i18n
}
</script>
